import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import EventSource from 'eventsource'
import { TFunction } from 'i18next'
import React, { useContext, useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import Authorization from '../../Authentication/Authorization'
import AuthService from '../../Authentication/AuthService'
import DialogContext from '../../Authentication/DialogContext'
import { ConfirmDialogProps } from '../../components/ConfirmDialog'
import ProtectedButton from '../../components/ProtectedButton'
import Loading from '../../layout/Loading'
import InfoService from '../../service/InfoService'

const Log = () => {
  const [log, setLog] = useState([] as any[])
  const [loading, setLoading] = useState(true)
  const [showDots, setShowDots] = useState(true)
  const { confirmDialogPropsSetter } = useContext(DialogContext)
  const { t } = useTranslation()

  useEffect(() => {
    const eventSource: any = new EventSource('/api/info/log/tail', {
      headers: {
        Authorization: AuthService.getAuthTokenHeader(),
      },
    })
    eventSource.onmessage = (event: any) => {
      setLog(JSON.parse(event.data))
      if (loading) {
        setLoading(false)
      }
      if (!showDots) {
        setShowDots(true)
      }
    }
    eventSource.onerror = (err: any) => {
      console.error('EventSource failed:', err)
      setLog(['Fetching log messages failed: ', err.message])
      eventSource.close()
      if (loading) {
        setLoading(false)
      }
      if (showDots) {
        setShowDots(false)
      }
    }
    return () => {
      eventSource.close()
      setLog(['event closed'])
      if (loading) {
        setLoading(false)
      }
      if (showDots) {
        setShowDots(false)
      }
    }
  }, [loading, showDots])

  return (
    <Loading isLoading={loading}>
      <Container fluid>
        <Row>
          <Col lg={8}>
            <h3 className='d-inline'>Log </h3>
          </Col>
          <Col className='text-right pr-1 ml-nfc-1' lg={4}>
            <ProtectedButton
              variant='primary'
              className='ml-auto my-auto'
              onClick={() => downloadLogFile(t, confirmDialogPropsSetter)}
              permissions={Authorization.info.LogFile}>
              <FontAwesomeIcon icon={faDownload} /> <span className='ml-1 my-auto'>{t('logfile.text')}</span>
            </ProtectedButton>
          </Col>
        </Row>
        <Row>
          <Col className='bg-dark mt-1'>
            <pre className='log-display text-white'>{log.join('')}</pre>
            {showDots && <div className='ml-3 mb-3 dot-flashing'></div>}
          </Col>
        </Row>
      </Container>
    </Loading>
  )
}

function downloadLogFile(t: TFunction, confirmDialogPropsSetter: any) {
  const props: ConfirmDialogProps = {
    show: true,
    header: t('logfile.downloadHeader'),
    body: t('logfile.downloadBody'),
    submitText: t('yes'),
    onSubmit: InfoService.downloadLogFile,
    cancelText: t('no'),
  }
  confirmDialogPropsSetter(props)
}

export default Log
